import { render } from "./AffiliateConfigModal.vue?vue&type=template&id=31c52410&scoped=true"
import script from "./AffiliateConfigModal.vue?vue&type=script&lang=js"
export * from "./AffiliateConfigModal.vue?vue&type=script&lang=js"

import "./AffiliateConfigModal.vue?vue&type=style&index=0&id=31c52410&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31c52410"]])

export default __exports__